export default {
	title: 'VMS',
	api: {
		auth: {
			key:
				'Wwqv4Euhlr+HF0G+FgSE4VwERGWN4368OuIONYxjfBcg07zF+niT0uj0Tl/hxngGahdbApprnDTZXtg/bjw+AA==',
			secret: 'ceca2b321834708288a7',
			jwt_secret: 'GOgOg0H1r3',
		},
		host: process.env.REACT_APP_API || 'http://localhost:8787',
		analytics: process.env.REACT_APP_ANALYTICS || 'http://localhost:3005',
	},
	mixpanel: {
		//production
		token: "47ceee1dd09fbfa15e81d6570859e508"
		//staging
		//token: "cab2370274fbee6f1b90e9c5e964750a"
	},
	version: 'v2.2.0',
	userRoles:{
		ghAdmin:'3de28f74-5675-4dca-b905-47ca3911e396',
		companyAdmin:'6978f868-0610-4544-9191-cc0178a02553',
		user:'4f4032ac-5f15-4da9-9c23-81bf886b051b'
	},
	store:{
		demoUrl:'https://gohire.com/recruiting-chatbot-demo/'
	},
	defaultInterviewModules: {
		calendly: '7c229e54-71be-472c-b5b6-d488024b21d4',
		cronofy: '966065f2-1811-4c88-8278-05d4ca2711b4',
		cronofyPostEventConfirmation: '9a3432ac-4da3-4c2f-afe1-96669e24d47e',
	}
};
